
@if (registerUser()) {
  @if (registerUser().pointListLoader?.length > 0) { <!-- TODO: Cuando esté el backend, ya no hará falta la ? --->
    <div class="carousel-loader">
      <div
        #swiper 
        class="carousel-loader__swiper swiper" 
      >
        <ul class="swiper-wrapper">
          @for(image of registerUser().pointListLoader; track image.id) {
            <li class="swiper-slide">
              <img 
                [src]="image.src" 
                [alt]="('Imagen de carga' | translate) + ' ' + getPointLoaderName(image.name)" 
              />
            </li>
          }
        </ul>
      </div>
      
      <div class="carousel-loader__text-container">
        <p class="carousel-loader__text ci-heading-h6-s-bold">
          {{ 'Estamos creando tu ruta personalizada' | translate }}
        </p>
        <p class="carousel-loader__text ci-paragraph-p1-regular">
          {{ 'Espere unos segundos' | translate }}...
        </p>
      </div>
    </div>
  } @else {
    <div class="carousel-loader">
      <div
        #swiper 
        class="carousel-loader__swiper swiper" 
      >
        <ul class="swiper-wrapper">
          @for(image of images; track image) {
            <li class="swiper-slide">
              <img 
                [src]="image" 
                [alt]="('Imagen de carga' | translate) + ' ' + image" 
              />
            </li>
          }
        </ul>
      </div>
      
      <div class="carousel-loader__text-container">
        <p class="carousel-loader__text ci-heading-h6-s-bold">
          {{ 'Estamos creando tu ruta personalizada' | translate }}
        </p>
        <p class="carousel-loader__text ci-paragraph-p1-regular">
          {{ 'Espere unos segundos' | translate }}...
        </p>
      </div>
    </div>
  }
}